/*
文章相关api（公告、咨询研究）
 */
import request from '../request';

export const articleApi = {
  /*
    获取文章列表（公告的category为：notice）
    data => {
      category, // 类型
      group, // 如果category为notice，则不需要，其他的可带article_research
      current, // 当前页码
      pageSize // 每页显示条数
    }
   */
  getArticleCategory (data) {
    return request.get(`/api/s/article/category`);
  },
  getArticleList (data) {
    let url;
    if (data.group) {
      // url = `/v2/s/article/${data.group}/notice/${data.current}/${data.pageSize}`;
    } else {
      url = `/gw/w/article/notice/${data.current}/${data.pageSize}`;
    }
    return request.get(url);
  },
  /*
    获取文章详情（不需要传type）
   */
  getArticleDetail (id) {
    return request.get(`/gw/w/article/${id}`);
  },
};
